module.exports = ["BannersOracle","WitchesOracle","NatureOracleNFTMinter"];